import { Clothes } from "./Clothes";
import { GeneralStaff } from "./GeneralStaff";
import { Job } from "./Job";
import { Ribbon } from "./Ribbon";
import { Weapon } from "./Weapon";

export class NocSizes {
    id: number;
    noc: string;
    npc: string;
    size: string;
    stock: number;
    sex: string;
    threshold:number;
    maxAmount:number;
    ribbon:Ribbon;
    job:Job;
    generalStaff:GeneralStaff;
    weapon:Weapon;
    internalCode:string;
    clothes?: Clothes
    modifiedNoc?: boolean;
    modifiedCode?: boolean;
}